export default __webpack_public_path__ + "static/media/st1.7123952f.jpg";